@if (showAmendmentDetails()) {
    <div data-test-automation="plan-amendment">
        <div class="container-fluid well">
            <h5>{{title}}</h5>
            <div class="row">
                <div class="col-xs-6">
                    <label
                        class="control-label required-input"
                        for="amendmentDescription">
                        Amendment details
                    </label>
                    <div
                        class="input-group"
                        [ngClass]="{'has-error': amendmentDescriptionTextarea | formFieldHasError}">
                        <span class="input-group-addon corner">
                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                        </span>
                        <textarea
                            class="form-control"
                            name="amendmentDescription"
                            id="amendmentDescription"
                            title="Enter {{title}}"
                            rows="4"
                            cols="50"
                            maxlength="1024"
                            required
                            data-test-automation="amendment-description"
                            [placeholder]="selectedPlanLodgementType.amendmentDescriptionLabel"
                            [disabled]="isAmendmentDescriptionDisabled()"
                            [(ngModel)]="getPlanModel().amendmentDescription"
                            #amendmentDescriptionTextarea="ngModel">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
